import { Card, Typography } from 'antd'
import { RocketOutlined } from '@ant-design/icons'
import type { User } from '../types/milestone.types'

const { Title, Text } = Typography

interface HomeProps {
  user: User | null
}

function Home({ user }: HomeProps) {
  return (
    <div style={{ maxWidth: '1280px', margin: '0 auto' }}>
      <Card>
        <div style={{ textAlign: 'center', padding: '64px 24px' }}>
          <RocketOutlined style={{ fontSize: '64px', color: '#1890ff', marginBottom: '24px' }} />
          <Title level={2} style={{ marginBottom: '8px' }}>
            {user ? `Welcome, ${user.name}!` : 'Welcome to Rocket Pricing'}
          </Title>
          <Text type="secondary" style={{ fontSize: '16px' }}>
            Please click the wrench icon above to get started.
          </Text>
        </div>
      </Card>
    </div>
  )
}

export default Home
